<style scoped lang="scss">
    .line_echarts {
        height: 330px !important;
    }
</style>
<template>
    <v-chart :options="data" class="line_echarts"></v-chart>
</template>

<script>
  import {isEmpty} from "../../../../common/lib/utils";

  export default {
    name: "line-echarts",
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    data() {
      return {
        data: {
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              rotate: 45
            },
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
          },
          series: [{
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line'
          }]
        }
      }
    },
    created() {
      this.getMon();
    },
    watch: {
      list() {
        this.getMon();
      }
    },
    methods: {
      getMon() {
        const {list} = this;
        let data = [];
        const handlerZero = (num) => {
          return num >= 10 ? num : `0${num}`;
        };
        const currMon = new Date().getMonth() + 1;
        const currYear = new Date().getFullYear();
        for (let i = 0; i < 12; i++) {
          let mon = currMon - i;
          let year = currYear;
          if (mon <= 0) {
            mon = 12 + mon;
            year--;
          }
          data.push(`${year}-${handlerZero(mon)}`);
        }
        data.reverse();
        this.data.xAxis.data = data;
        if (!list || !list.length)
          this.data.series[0].data = '0'.repeat(12).split('').map(r => Math.random() * 100);
        else {
          this.data.series[0].data.splice(0);
          data.forEach(r => {
            const m = list.find(rr => rr.emergencyDate === r);
            if (!isEmpty(m))
              this.data.series[0].data.push(m.emergencyCount);
            else this.data.series[0].data.push(0);
          })
        }
      }
    },
  }
</script>

